import React from "react";
import { createIcon } from "@chakra-ui/react";

const RightIcon = createIcon({
  displayName: "RightIcon",
  viewBox: "0 0 18 21",
  path: (
    <>
      <path
        d="M0 20.3359H18V18.169H0V20.3359ZM6 16.0022H18V13.8353H6V16.0022ZM0 11.6685H18V9.50164H0V11.6685ZM6 7.33479H18V5.16795H6V7.33479ZM0 0.834259V3.0011H18V0.834259H0Z"
        fill="currentColor"
      />
      ,
    </>
  ),
});

export default RightIcon;
